(function () {
  if (!document.body) return;

  /* ------------------------------------------------------------------
    customCartEmpty : properly empties the cart with the Shopify Ajax API
    ------------------------------------------------------------------ */
  async function customCartEmpty() {
    try {
      const res = await fetch(window.Shopify.routes.root + "cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status} from cart clear API`);
      }

      const cart = await res.json();

      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));

      // Dispatch cartcount:update event like Empire theme
      const countEvent = new CustomEvent("cartcount:update", {
        detail: cart,
      });
      window.dispatchEvent(countEvent);

      return cart;
    } catch (err) {
      console.error("[CartEmpty] empty failed:", err);
      throw err;
    }
  }

  /* ------------------------------------------------------------------
     Empty Cart Button on Static Cart Page
     ------------------------------------------------------------------ */
  function initializeEmptyCartButton() {
    document.body.addEventListener("click", function (e) {
      const emptyButton = e.target.closest("#empty-cart-btn");
      if (!emptyButton) return;

      e.preventDefault();
      e.stopPropagation();

      if (emptyButton.hasAttribute("data-processing")) {
        return;
      }
      emptyButton.setAttribute("data-processing", "true");
      emptyButton.classList.add("disabled");

      const originalContent = emptyButton.innerHTML;
      emptyButton.innerHTML = `
        EN COURS...
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20" style="width: 20px; height: 20px; display: inline-block; vertical-align: middle; margin-left: 8px; animation: spin 1s linear infinite;"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.455-1.372A6.75 6.75 0 1 1 10 3.25a1.25 1.25 0 1 0 0-2.5 9.25 9.25 0 0 0-2.771.423z" fill="currentColor"/><style>@keyframes spin { to { transform: rotate(360deg); } }</style></svg>
      `;

      if (typeof window.customCartEmpty === "function") {
        window
          .customCartEmpty()
          .then(cart => {
            if (
              document.body.classList.contains("template-cart") &&
              typeof window.refreshCartPageSection === "function"
            ) {
              window.refreshCartPageSection();
            }
          })
          .catch(err => {
            console.error("[StaticCart] Error emptying cart:", err);
            emptyButton.removeAttribute("data-processing");
            emptyButton.classList.remove("disabled");
            emptyButton.innerHTML = originalContent;
          });
      } else {
        console.error("[StaticCart] `customCartEmpty` function is not available.");
        emptyButton.removeAttribute("data-processing");
        emptyButton.classList.remove("disabled");
        emptyButton.innerHTML = originalContent;
      }
    });
  }

  /* ------------------------------------------------------------------
     Custom Cart Remove on Static Cart Page
     ------------------------------------------------------------------ */
  function initializeStaticCartRemove() {
    if (document.body.hasAttribute("data-static-cart-remove-init")) return;
    document.body.setAttribute("data-static-cart-remove-init", "true");

    document.body.addEventListener(
      "click",
      function (e) {
        const removeLink = e.target.closest(".template-cart .cart-item__remove-link");
        if (!removeLink) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const cartItem = removeLink.closest(".cart-item");
        if (!cartItem) return;

        const lineKey = cartItem.getAttribute("data-cartitem-key");
        if (!lineKey) {
          console.error("[StaticCart] Remove failed: cart item key not found.");
          return;
        }

        cartItem.classList.add("removing");

        if (typeof window.customCartRemove === "function") {
          window
            .customCartRemove(lineKey)
            .then(cart => {
              if (typeof window.showSuccessToast === "function") {
                window.showSuccessToast("Article supprimé du panier.");
              }
              if (
                document.body.classList.contains("template-cart") &&
                typeof window.refreshCartPageSection === "function"
              ) {
                window.refreshCartPageSection();
              }
            })
            .catch(err => {
              console.error("[StaticCart] Error removing item:", err);
              cartItem.classList.remove("removing");
              if (typeof window.showFailedToast === "function") {
                window.showFailedToast("Erreur lors de la suppression de l'article.");
              }
            });
        } else {
          console.error("[StaticCart] `customCartRemove` function is not available.");
          cartItem.classList.remove("removing");
        }
      },
      true
    );
  }

  // --- Global exposure and initializers ---
  window.customCartEmpty = customCartEmpty;

  document.addEventListener("DOMContentLoaded", () => {
    initializeEmptyCartButton();
    initializeStaticCartRemove();
  });

  document.addEventListener("shopify:section:load", e => {
    if (e.target.matches("#shopify-section-static-cart")) {
      initializeStaticCartRemove();
      // We don't need to re-initialize the empty cart button here
      // as it's attached to the body and persists across section reloads.
    }
  });
})();
